import loadable from '@loadable/component';

export const NotificationsDropdownContainerLoadable = loadable(
  () => import('./NotificationsDropdownContainer'),
  { resolveComponent: (module) => module.NotificationsDropdownContainer },
);
